<template>
  <header ref="header" :class="{ isHidden: !isVisible, isSticky: isSticky }">
    <div class="container-fluid wrap">
      <div class="row middle-xs center-xs">
        <div class="col-md-12">
          <router-link to="/">
            <SfImage
              v-if="getLogo()"
              :src="getLogo()"
              :alt="headerTitle()"
              class="sf-header__logo"
            />
            <h1 v-else-if="title">{{ headerTitle() }}</h1>
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { SfImage } from '@storefront-ui/vue';

import routes from '../../mixins/routes';
import config from '../../mixins/config';
import headerSticky from '../../mixins/headerSticky';

export default {
  name: 'Header',
  mixins: [routes, headerSticky, config],
  components: {
    SfImage,
  },
};
</script>
<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
.isSticky {
  z-index: var(--header-z-index, 1);
  background: var(--header-sticky-container-background, var(--c-white));
  position: sticky;
  top: 0;
  width: 100%;
  transition: transform 150ms ease-in-out;
}
.isHidden {
  transition: transform 150ms ease-in-out;
  transform: translate3d(0, -100%, 0);
}
</style>
